var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileSketch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46402 17.7028L5.61787 18.8567L6.39074 18.0838L5.23688 16.93L7.34865 14.8182L8.50251 15.972L9.27537 15.1992L8.12152 14.0453L10.2333 11.9336L11.3871 13.0874L12.16 12.3145L11.0062 11.1607L13.1288 9.03803L14.2827 10.1919L15.0555 9.41902L13.9017 8.26517L16.0134 6.1534L17.1673 7.30725L17.9402 6.53439L16.7863 5.38053L19 3V18C19 19.1974 18.1974 20 17 20H2L4.46402 17.7028ZM16 17V11L10 17H16Z",
    fill: "#212122"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSketch);
export default __webpack_public_path__ + "static/media/mobile-sketch.0fb9a751.svg";
export { ForwardRef as ReactComponent };